import NextLink from 'next/link';
import { LinkProps as NextLinkProps } from 'next/link';
import { ReactNode } from 'react';

// NextLinkProps에서 href를 제외한 타입 생성
type OmitHrefLinkProps = Omit<NextLinkProps, 'href'>;

interface LinkProps extends OmitHrefLinkProps {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'primary' | 'secondary';
  href?: string | URL; // href를 선택적으로 설정
  openInNewTab?: boolean; // 새 창에서 열기 여부
}

const Link = ({
  href,
  children,
  variant = 'default',
  className = '',
  openInNewTab = false,
  ...props
}: LinkProps) => {
  const variantClasses = {
    default: 'bg-[var(--link-bg)] text-[var(--link-text)] hover:bg-[var(--link-hover-bg)] hover:text-[var(--link-hover-text)] px-0.5 py-0 rounded-sm transition-colors duration-200 font-medium',
    primary: 'bg-primary text-primary-foreground hover:bg-[var(--link-hover-bg)] hover:text-[var(--link-hover-text)] px-1.5 py-0.5 rounded-sm transition-colors duration-200 font-medium',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-[var(--link-hover-bg)] hover:text-[var(--link-hover-text)] px-1.5 py-0.5 rounded-sm transition-colors duration-200 font-medium'
  };

  // 공통 클래스명 문자열
  const classNames = `inline-flex items-center ${variantClasses[variant]} ${className}`;

  // href가 있는 경우 NextLink 반환, 없는 경우 span 반환
  return href ? (
    <NextLink
      href={href}
      className={classNames}
      {...(openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      {...props}
    >
      {children}
    </NextLink>
  ) : (
    <span className={classNames} role="button" {...props}>
      {children}
    </span>
  );
};

export default Link;